// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CommaFormat } from '../../../../../elements/Price/Price';
import Tooltip from '../../../../../elements/Tooltip/Tooltip';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { groupItems } from '../../../../new-order/QuoteStep/utils';
import { LoadingContentStripe } from '../../../../../elements/LoadingContentFigures/LoadingContentFigures';
import classNames from 'classnames/bind';

import style from './SaleSummary.scss';
import icons from '../../../../../assets/styles/icons.scss';
import loadingStripeStyle from '../../../../../elements/LoadingContentFigures/LoadingContentFigures.scss';

import type { BagItem, Order, ShoppingCartItem } from '../../../../../entities';
import type { ItemsByStore } from '../../../../new-order/QuoteStep/components/QuoteSummary/QuoteSummary';
import formStyle from '../../../../../assets/styles/form.scss';
import moment from 'moment';
import { getPaymentInfo } from '../../../../new-order/CheckoutStep/utils';

type Item = ShoppingCartItem | BagItem;

type Props = {
  order: Order;
};

type State = {
  openShipping: boolean;
};

export const SaleSummaryLoading = () => (
  <section className={style.summaryWrap}>
    <FormattedMessage id="order.sale.summary.title.orderDetail">{
      txt => <h3 className={style.title}>{txt}</h3>
    }</FormattedMessage>
    {/*<article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black100}/>
    </article>*/}
    <article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black200}/>
    </article>
    <article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black100}/>
    </article>
    <article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black100}/>
    </article>
    {/*<section className={classNames(style.shippingContent, style.loading)}>
      <article className={style.wrap}>
        <FormattedMessage id="order.sale.summary.shipping">{
          txt => <span>{txt}</span>
        }</FormattedMessage>
        <LoadingContentStripe colorClassName={classNames(loadingStripeStyle.black100, style.loadingStripeTotal)}/>
      </article>
    </section>
    <article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black100}/>
    </article>
    <article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black100}/>
    </article>*/}
    <article className={style.wrap}>
      <FormattedMessage id="order.sale.summary.total">{
        txt => <span className={style.total}>{txt}</span>
      }</FormattedMessage>
      <LoadingContentStripe colorClassName={classNames(loadingStripeStyle.black200, style.loadingStripeTotal)}/>
    </article>
  </section>);

export default class SaleSummary extends Component<Props, State> {
  state = {
    openShipping: false,
  };

  render() {
    const { order } = this.props;
    const { openShipping } = this.state;
    const itemsByStores: ?ItemsByStore[] = order && groupItems(order.items);
    return (
      <Fragment>
        <section className={style.summaryWrap}>
          <FormattedMessage id="order.sale.summary.title.orderDetail">{
            txt => <h3 className={style.title}>{txt} #{order && order.id}</h3>
          }</FormattedMessage>
          <section className={classNames(formStyle.formWrap, style.formWrap)}>
            <section className={formStyle.row}>
              <article className={classNames(formStyle.col, style.deliveryBefore)}>
                <FormattedMessage id="order.sale.summary.purchaseDate">{
                  txt => (<label><i className={icons.iconDeliverBoxMedium}/>{txt}:</label>)
                }</FormattedMessage>
                <p>{moment(order.beforeDate).utc().format('MMM DD, YYYY', { trim: false })}</p>
              </article>
            </section>
            {/*<section className={formStyle.row}>
              <article className={classNames(formStyle.col, style.order)}>
                <FormattedMessage id="order.sale.summary.order">{
                  txt => (<label>{txt} #{order && order.id}</label>)
                }</FormattedMessage>
              </article>
            </section>*/}
          </section>
          <article className={style.wrap}>
            <FormattedMessage id="order.sale.summary.value">{
              txt => <span>
                {txt}: <Tooltip id="product"
                                intl="order.sale.summary.value.tooltip"/>
              </span>
            }</FormattedMessage>
            <span>$ {order && <CommaFormat price={order.invoice.detail.subtotal}/>}</span>
          </article>
          {/*<article className={classNames(style.shipping, style.wrap, { [style.open]: openShipping })}
                   onClick={_ => this.setState((state: State) => ({ openShipping: !state.openShipping }))}>
            <FormattedMessage id="order.sale.summary.shipping">{
              txt => <span><i className={classNames(
                { [icons.iconChevronUpMedium]: openShipping },
                { [icons.iconChevronDownMedium]: !openShipping })}/> {txt}:</span>
            }</FormattedMessage>
            <span>{`$ ${order && order.invoice.detail.shipping}`}</span>
          </article>
          {openShipping && <section className={style.shippingContent}>
            {itemsByStores && itemsByStores.map((x: ItemsByStore, i: number) => {
              const s = x.items.reduce((acum: number, i: Item) => acum + parseFloat(i.shipping), 0).toFixed(2);
              const a = x.items.reduce((acum: number, i: Item) => acum + i.amount, 0);
              return <article key={i}
                              className={style.wrap}>
                <span className={style.shippingContentText}>({a}) {x.name}</span>
                <span className={style.shippingContentText}>$ {s}</span>
              </article>;
            })}
          </section>}*/}
          <article className={style.wrap}>
            <FormattedMessage id="order.sale.summary.taxes">{
              txt => <span>{txt}:</span>
            }</FormattedMessage>
            <span>$ {order && <CommaFormat price={order.invoice.detail.taxes}/>}</span>
          </article>
          {order &&
          order.invoice.detail.customsDuties &&
          order.invoice.detail.customsDuties !== '0.00' &&
          <article className={style.wrap}>
            <FormattedMessage id="order.sale.summary.customsDuties">{
              txt => <span>{txt}:</span>
            }</FormattedMessage>
            <span>$ {order && <CommaFormat price={order.invoice.detail.customsDuties}/>}</span>
          </article>}
          <article className={style.wrap}>
            <FormattedMessage id="order.sale.summary.commission">{
              txt => <span>{txt}: <Tooltip id="commission" intl="order.sale.summary.commission.tooltip"/></span>
            }</FormattedMessage>
            <span>$ {order && <CommaFormat price={order.invoice.detail.commission}/>}</span>
          </article>
          <hr/>
          <article className={style.wrap}>
            <FormattedMessage id="order.sale.summary.total">{
              txt => <span className={classNames(style.total, style.orange)}>
                {txt}: <Tooltip id="total"
                                intl="order.sale.summary.total.tooltip"/>
              </span>
            }</FormattedMessage>
            <span className={classNames(style.total, style.orange)}>$&nbsp;
              <CommaFormat price={order && order.invoice.detail.total}/></span>
          </article>
        </section>
        {order && order.state === 'RESERVED' && (
          <FormattedMessage id="order.sale.summary.note">{
            txt => <p className={style.saleSummaryNote}>{txt}:</p>
          }</FormattedMessage>)
        }
      </Fragment>
    );
  }
}

SaleSummary.propTypes = {
  order: PropTypes.object,
};

SaleSummary.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/order/Sale/components/SaleSummary/SaleSummary.jsx